import { render, staticRenderFns } from "./home-choose.vue?vue&type=template&id=1c840223&scoped=true"
import script from "./home-choose.vue?vue&type=script&lang=js"
export * from "./home-choose.vue?vue&type=script&lang=js"
import style0 from "./home-choose.vue?vue&type=style&index=0&id=1c840223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c840223",
  null
  
)

export default component.exports